import { addStyles } from 'ethcss'
import { grid, item, IStyles } from 'theme'
import { colors } from 'theme'
import { mediaCSS, textSizes } from 'theme/media'

const displaysDatetimeStyles: IStyles = {
    modalWrapper: {
        ...grid.full,
        ...grid.rowCenter,
    },
    modalInner: {
        maxHeight: '96%',

        [mediaCSS.tabMini]: {
            ...grid.w90,
            maxHeight: '90vh',
            overflow: 'auto',
            paddingBottom: 70,
        },
        ...item.card,
        ...grid.p_md,
        ...item.shadowModal,
        ...item.rounded_full_mini,
        ...item.rel,
        width: '1000px !important',
        maxWidth: '95vw',
    },
    buttons: {
        ...grid.row,
        ...grid.mt_big,
        ...grid.pr_mini,
        ...grid.pl_mini,
        ...grid.center,
        position: 'absolute',
        bottom: 30,
        left: '50%',
        transform: 'translateX(-50%)',

        [mediaCSS.tabMini]: {
            transform: 'none',
            left: 0,
            right: 0,
        },
    },
    title: {
        fontSize: textSizes.normalPlus,
        fontWeight: 600,
        ...grid.mb_mini,
    },
    description: {
        ...grid.mt_micro,
        ...grid.mb_md,
        color: colors.darkCloud,
        fontSize: textSizes.mini,
    },
    content: {
        ...grid.justify,
        ...grid.mt_md,
        ...grid.mb_md,
        ...grid.row,
        gap: '16px',
        [mediaCSS.tabMini]: {
            display: 'block',
        },
    },
    loaderWrapper: {
        position: 'absolute',
        top: 212,
        left: 21,

        [mediaCSS.tabMini]: {
            display: 'none',
        },
    },
    loader: {
        fontSize: 16,
    },
    devicesTable: {
        ...grid.mt_md,
        marginBottom: 70,
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 8,
        overflow: 'hidden',
        backgroundColor: colors.white,

        [mediaCSS.mini]: {
            minWidth: 570,
            overflow: 'auto',
            marginBottom: 0,
        },
    },
    tableHeader: {
        display: 'flex',
        backgroundColor: colors.greyModal,
        borderBottom: `1px solid ${colors.greyLight}`,
        fontWeight: 600,
        fontSize: textSizes.mini,
        minHeight: 48,
    },
    headerCell: {
        ...grid.p_mini,
        borderRight: `1px solid ${colors.greyLight}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:first-child': {
            flex: '0 0 50px',
        },
        '&:nth-child(2)': {
            flex: '0 0 120px',
        },
        '&:nth-child(3)': {
            flex: '1 1 200px',
            justifyContent: 'flex-start',
        },
        '&:nth-child(4)': {
            flex: '0 0 100px',
        },
        '&:nth-child(5)': {
            flex: '0 0 120px',
        },
        '&:nth-child(6)': {
            flex: '1 1 180px',
            justifyContent: 'flex-start',
        },
        '&:nth-child(7)': {
            flex: '0 0 140px',
        },
        '&:last-child': {
            borderRight: 'none',
        },
    },
    tableRow: {
        display: 'flex',
        borderBottom: `1px solid ${colors.greyLight}`,
        minHeight: 48,
        textAlign: 'center',
        '&:last-child': {
            borderBottom: 'none',
        },
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
    },
    tableCell: {
        ...grid.p_mini,
        borderRight: `1px solid ${colors.greyLight}`,
        display: 'flex',
        alignItems: 'center',
        fontSize: textSizes.mini,

        '>div': {
            width: '100%',
        },

        '&:first-child': {
            flex: '0 0 50px',
            justifyContent: 'center',
        },
        '&:nth-child(2)': {
            flex: '0 0 120px',
            justifyContent: 'center',
        },
        '&:nth-child(3)': {
            flex: '1 1 200px',
            justifyContent: 'flex-start',
            ...item.ellipsis,
        },
        '&:nth-child(4)': {
            flex: '0 0 100px',
            justifyContent: 'center',
        },
        '&:nth-child(5)': {
            flex: '0 0 120px',
            justifyContent: 'center',
        },
        '&:nth-child(6)': {
            flex: '1 1 180px',
            justifyContent: 'flex-start',
            ...item.ellipsis,
        },
        '&:nth-child(7)': {
            flex: '0 0 140px',
            justifyContent: 'center',
        },
        '&:last-child': {
            borderRight: 'none',
        },
    },
    checkbox: {
        width: 16,
        height: 16,
        cursor: 'pointer',
    },
    idText: {
        color: colors.darkCloud,
        fontSize: textSizes.mini,
    },
    [mediaCSS.tabMini]: {
        devicesTable: {
            display: 'block',
        },
        tableHeader: {
            display: 'none',
        },
        tableRow: {
            display: 'block',
            ...grid.mb_mini,
            ...grid.p_mini,
            border: `1px solid ${colors.greyLight}`,
            borderRadius: 8,
        },
        tableCell: {
            display: 'flex',
            justifyContent: 'space-between',
            border: 'none',
            ...grid.mb_micro,
            minHeight: 'auto',
            '&:before': {
                content: 'attr(data-label)',
                fontWeight: 600,
                marginRight: 8,
                minWidth: 120,
                flexShrink: 0,
            },
            '&:first-child': {
                justifyContent: 'center',
                '&:before': {
                    content: '""',
                },
            },
        },
    },
    displaysDatetime__inputWrapper_type_date: {
        flex: '0 0 200px',
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mb_md,
        },
    },
    displaysDatetime__inputWrapper_type_time: {
        flex: '0 0 200px',
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mb_md,
        },
    },
    displaysDatetime__inputWrapper_type_timezone: {
        flex: '1 1 300px',
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    switchLabel: {
        marginBottom: 6,
    },
    errorText: {
        color: colors.error,
    },
    autoAssetLabel: {
        marginBottom: 7,
    },
    desktopOnly: {
        [mediaCSS.tab]: {
            display: 'none',
        },
    },
    tableList: {
        overflow: 'auto',
        maxHeight: '40vh',

        [mediaCSS.tabMini]: {
            maxHeight: '100%',
        },
    },
    contentWrapper: {
        [mediaCSS.tabMini]: {
            maxHeight: 'calc(100vh - 210px)',
            overflow: 'auto',
        },
    },
}

addStyles(displaysDatetimeStyles)
export default displaysDatetimeStyles
